import React from 'react';
import styled from 'styled-components/macro';
import { useField } from 'formik';
import { Q1Value } from 'models/documents';
import { AIsuggestion } from 'models/response';

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  height: auto;
  width: auto;
  margin-right: 17px;
  justify-content: flex-end;
`;
const InputsWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const InputLabel = styled.div`
  display: inline-block;
  margin-right: 10px;
  margin-top: 7px;
  font-size: ${({ theme }) => theme.fontSizePalette.xxSmall};
  width: 100px;
  overflow: hidden;
  letter-spacing: -0.31px;
  color: ${({ theme }) => theme.colorPalette.grey.grey9};
  text-align: right;
`;

const InputContainer = styled.div`
  width: 440px;
`;

interface Props {
  InputComponent: (props: any) => JSX.Element;
  idField: number;
  name: string;
  label: string;
  readonly?: boolean;
}

const MultiInput = (props: Props) => {
  const { InputComponent, name, label } = props;
  const [field, , helpers] = useField<Q1Value | undefined>(name);

  const addInputAction = () => {
    if (field.value && Array.isArray(field.value.content)) {
      const newObj: AIsuggestion = {
        ...field.value.content[0],
        content: '',
        boundingBox: { x1: -1, x2: -1, y1: -1, y2: -1 },
        pageNumber: -1,
        confidence: -1,
        status: 0,
      };
      const inputs = [...field.value.content];
      inputs.push(newObj);
      helpers.setValue({
        ...field.value,
        content: inputs,
      });
    }
  };

  const removeInputAction = (i: number) => {
    if (field.value && Array.isArray(field.value.content)) {
      const inputs = [...field.value.content];
      inputs.splice(i, 1);
      helpers.setValue({
        ...field.value,
        content: inputs,
      });
    }
  };

  return (
    <Wrapper>
      <InputLabel title={label}>{label}</InputLabel>
      <InputsWrapper>
        {Array.isArray(field.value?.content) &&
          field.value?.content.map((value: any, i: number) => (
            <InputContainer key={props.idField + i}>
              {i === 0 ? (
                <InputComponent index={i} addAction={addInputAction} />
              ) : (
                <InputComponent index={i} removeAction={() => removeInputAction(i)} />
              )}
            </InputContainer>
          ))}
      </InputsWrapper>
    </Wrapper>
  );
};

export default MultiInput;
